// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"styles_dropzone__3hFRz","fileList":"styles_fileList__2dc30"};